import React from 'react';
import { motion } from 'framer-motion';
const examples = [{
  title: 'Mini Pote de Doce',
  image: 'https://i.ibb.co/ccdJ5wmY/Lembrancinha-Rustica-Com-Doce-De-Leite-120ml-Com-Folha-Aniversario-E-Festas-Festa-Fazendinha-Abr.jpg'
}, {
  title: 'Mini Terrário',
  image: 'https://i.ibb.co/gZcXWFgp/download-5.jpg'
}, {
  title: 'Amêndoas',
  image: 'https://i.ibb.co/rKrs2Kby/download-10.jpg'
}, {
  title: 'Sal de Banho',
  image: 'https://i.ibb.co/d0Dd1yQm/Whats-App-Image-2025-12-01-at-19-07-27-1.jpg'
}];
export function ExamplesSection() {
  return <section className="py-12 md:py-20 bg-gradient-to-br from-stone-50 to-amber-50" data-id="element-27">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-29">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-4 md:mb-6" data-id="element-30">
            Algumas das ideias que você aprende a montar
          </h2>
          <p className="text-sm md:text-base text-stone-600 max-w-3xl mx-auto" data-id="element-31">
            Todas pensadas para parecerem profissionais, valorizadas e
            vendáveis.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-32">
          {examples.map((example, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-xl md:rounded-2xl shadow-lg overflow-hidden group border border-stone-100" data-id="element-33">
              <div className="aspect-[4/3] md:aspect-square overflow-hidden" data-id="element-34">
                <img src={example.image} alt={example.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-35" />
              </div>
              <div className="p-3 md:p-4 bg-white" data-id="element-36">
                <h3 className="text-sm md:text-base font-semibold text-stone-900 text-center" data-id="element-37">
                  {example.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}